import { db } from "helpers/firebase/firebaseConfig";
import { collection, query, where, getDocs, orderBy, doc, getDoc } from "firebase/firestore";
import Cookies from "js-cookie";
import { actionTypes, setCustomerSettlements, setCustomerSettlementsError, setCustomerSettlementsLoading } from "./actions";
import { call, put, takeEvery } from 'redux-saga/effects';

async function fetchSettlementsFromFirebase() {
  try {
    const userId = Cookies.get("usersessionId", {
      secure: true,
      sameSite: "strict",
      path: "/",
    });

    if (!userId) throw new Error("User ID not found");

    // Fetch customer settlements for this service provider
    const settlementsQuery = query(
      collection(db, "customer_settlements"),
      where("service_provider.id", "==", userId),
      orderBy("created_at", "desc")
    );
    
    const settlementsSnapshot = await getDocs(settlementsQuery);
    
    const settlements = [];
    settlementsSnapshot.forEach(doc => {
      settlements.push({
        id: doc.id,
        ...doc.data()
      });
    });

    // Also fetch batch settlements for this provider
    const batchSettlementsQuery = query(
      collection(db, "batch_settlements"),
      where("service_provider_id", "==", userId),
      orderBy("created_at", "desc")
    );
    
    const batchSettlementsSnapshot = await getDocs(batchSettlementsQuery);
    
    const batchSettlements = [];
    batchSettlementsSnapshot.forEach(doc => {
      batchSettlements.push({
        id: doc.id,
        is_batch: true,
        ...doc.data()
      });
    });

    // Combine and sort all settlements by date
    const allSettlements = [...settlements, ...batchSettlements].sort((a, b) => {
      const dateA = new Date(a.created_at || a.settlement_date || 0);
      const dateB = new Date(b.created_at || b.settlement_date || 0);
      return dateB - dateA;
    });

    return allSettlements;
  } catch (error) {
    console.error("Error fetching customer settlements:", error);
    throw error;
  }
}

function* fetchCustomerSettlementsSaga() {
  try {
    yield put(setCustomerSettlementsLoading(true));
    const settlements = yield call(fetchSettlementsFromFirebase);
    yield put(setCustomerSettlements(settlements));
  } catch (error) {
    console.error("Saga error:", error);
    yield put(setCustomerSettlementsError(error.message));
  }
}

export default function* customerSettlementsSaga() {
  yield takeEvery(actionTypes.FETCH_CUSTOMER_SETTLEMENTS, fetchCustomerSettlementsSaga);
}
